module.exports = __webpack_public_path__ + "img/governance-bannner8.29fa4ad5.png";